import select2 from 'select2';
import { Helpers } from './helpers';

select2();

$(document).ready(() => {
  const locale = Helpers.documentLocale();

  // Remove the country code to only get the 2-letter code
  let language = String(locale).slice(0, 2);

  if (language === "") {
    language = "fr";
  }

  $(".select-custom").select2(
    {
      minimumResultsForSearch: Infinity, // remove search bar
      language: language
    }
  );
});
